export default __webpack_public_path__ + "static/media/ico_purchase_white.a5126588.svg";